import React, { FC, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { viewRecords } from "../../firebase/db/releases/crud.tsx";
import MainTabs from "../partials/main-tabs.jsx";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useAuth } from "../../contexts/authContext/";
import FormModal from "../partials/form-modals/releases/new-form.jsx";
import { useNavigate } from "react-router-dom";

// Setup the localizer by providing the moment (or globalize, or Luxon) Object
// to the correct localizer.
const localizer = momentLocalizer(moment); // or globalizeLocalizer

const myEventsList = [{ start: new Date(), end: new Date(), title: "Some event" }];

interface EventInterface {
	title?: String;
	start: Date;
	end?: Date;
	allDay?: boolean;
	resource?: any;
}

const MyCalendar: FC = (props) => {
	const navigate = useNavigate();
	const { currentUser } = useAuth(); // Get currentUser from useAuth
	const [calenderData, setCalendarData] = useState<EventInterface[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<String | null>(null);
	const [isModalOpen, setModalOpen] = useState(false);

	useEffect(() => {
		const fetchDataAndSetState = async () => {
			try {
				console.log("Fetching data...");
				const fetchedData = await viewRecords(currentUser);
				const data: EventInterface[] = [];
				fetchedData.forEach((d) => {
					if (d.release_date) {
						data.push({
							title: d.release_id,
							start: d.release_date.toDate(),
							end: d.release_date.toDate(),
							allDay: true
						});
					}
				});
				setCalendarData(data);
			} catch (e) {
				setError(e); //More informative error message
			} finally {
				setIsLoading(false);
			}
		};

		fetchDataAndSetState();
	}, []);

	return (
		<div className="main-tabs">
			<div className="mx-auto">
				<MainTabs tabIndexSelected={2} />
				<div id="myTabContent">
					<div className="flex justify-between w-full page-header">
						<div className="page-heading">
							<img src="../../../assets/icons/releases-icon.png" alt="Fans" className="icon" />
							<h2 className="text-4xl font-bold dark:text-white">
								<span className="text-transparent bg-clip-text bg-gradient-to-r to-sky-500 from-cyan-700">RELEASES</span>
							</h2>
						</div>
						<div>
							<div className="inline-flex rounded-md shadow-xs" role="group">
								<button
									onClick={() => navigate(`/releases/`)}
									type="button"
									className="rounded-s-lg border border-r-0 text-slate-400 hover:text-cyan-700 border-slate-600 focus:outline-none focus:ring-2 focus:text-cyan-700 focus:ring-cyan-700 font-medium text-sm px-4 py-2 mb-2">
									List
								</button>
								<button
									disabled
									type="button"
									className="rounded-e-lg mr-4 border text-slate-400 hover:text-cyan-700 border-slate-600 focus:outline-none focus:ring-2 focus:text-cyan-700 focus:ring-cyan-700 font-medium text-sm px-4 py-2 me-2 mb-2">
									Calendar
								</button>
							</div>
							<button
								onClick={() => setModalOpen(true)}
								type="button"
								className="border text-slate-400 hover:text-cyan-700 border-slate-600 focus:outline-none focus:ring-2 focus:text-cyan-700 focus:ring-cyan-700 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
								New Release
							</button>
						</div>
					</div>
					<div className="shadow-xl bg-slate-500 p-4 rounded-lg tabpanel" id="profile" role="tabpanel" aria-labelledby="profile-tab">
						<div className="release-calendar">
							<Calendar
								views={["month"]}
								title="Release Calendar"
								localizer={localizer}
								events={calenderData}
								startAccessor="start"
								endAccessor="end"
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="h-screen flex items-center justify-center">
				<FormModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
			</div>
		</div>
	);
};

export default MyCalendar;
